import React, { useEffect, useState } from 'react';
import { Grid, Typography } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DatePicker from 'react-multi-date-picker';
import { useDateRange } from '../../Context/FormLimited/DateRangeContext';
import { useLocation } from 'react-router-dom';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';

const DateDisableForm = () => {

    const { dateRange, handleDateChange } = useDateRange();
    const location = useLocation();
    const [localFromDate, setLocalFromDate] = useState(dateRange.fromDate);
    const [localToDate, setLocalToDate] = useState(dateRange.toDate);
    const [resetKey, setResetKey] = useState(0); // Used to force remount

    useEffect(() => {
        setLocalFromDate(dateRange.fromDate);
        setLocalToDate(dateRange.toDate);
    }, [dateRange.fromDate, dateRange.toDate]);

    // Force clear local state and re-render DatePicker on leaving /Setting
    useEffect(() => {
        if (!location.pathname.includes('/setting')) {
            setLocalFromDate(null);
            setLocalToDate(null);
            setResetKey(prev => prev + 1); // Change key to force remount
        }
    }, [location.pathname]);

    return (
        <Grid width={'100%'} mt={'24px'}>
            <Typography variant={'h5'} color={'rgba(10,21,81,1)'} fontWeight={700} mb={'4px'}>
                تاریخ انقضای فرم
            </Typography>
            <Typography variant={'h6'} color={'rgba(108,115,168,1)'} fontWeight={500} mb={'12px'}>
                فرم در این بازه‌ی تاریخ فعال خواهد بود
            </Typography>
            <Grid className={'date'} display={'flex'} gap={'16px'} flexDirection={{ xs: 'column', md: 'row' }} alignItems={{ xs: 'flex-start', md: 'center' }} width={'100%'}>
                {/* From Date */}
                <Grid display={'flex'} flexDirection={'column'} alignItems={'flex-start'} width={{ xs: '100%', md: '50%' }}>
                    <Typography variant={'h5'} color={'rgba(10,21,81,1)'} fontWeight={700} mb={'8px'}>
                        از تاریخ
                    </Typography>
                    <Grid className="custom-input-wrapper" width={'100%'}>
                        <Grid width={'100%'}>
                            <DatePicker
                                key={`from-${resetKey}`}
                                value={localFromDate}
                                onChange={(date) => {
                                    setLocalFromDate(date);
                                    handleDateChange('fromDate', date);
                                }}
                                calendar={persian}
                                locale={persian_fa}
                                format="YYYY/MM/DD"
                                digits={false}
                                style={{
                                    border: 'none',
                                    border: 'none',
                                    outline: 'none',
                                    boxShadow: 'none',
                                    boxShadow: 'none',
                                    width: '100%',
                                    padding: '0px 24px 4px 0px',
                                    backgroundColor: 'rgba(255,255,255,0.1)',
                                }}
                            />
                        </Grid>
                        <CalendarMonthIcon className={'iconDatePicker'} />
                    </Grid>
                </Grid>

                {/* To Date */}
                <Grid display={'flex'} flexDirection={'column'} alignItems={'flex-start'} width={{ xs: '100%', md: '50%' }}>
                    <Typography variant={'h5'} color={'rgba(10,21,81,1)'} fontWeight={700} mb={'8px'}>
                        تا تاریخ
                    </Typography>
                    <Grid className="custom-input-wrapper" width={'100%'}>
                        <Grid width={'100%'}>
                            <DatePicker
                                key={`to-${resetKey}`}
                                value={localToDate}
                                onChange={(date) => {
                                    setLocalToDate(date);
                                    handleDateChange('toDate', date);
                                }}
                                calendar={persian}
                                locale={persian_fa}
                                format="YYYY/MM/DD"
                                digits={false}
                                style={{
                                    border: 'none',
                                    border: 'none',
                                    outline: 'none',
                                    boxShadow: 'none',
                                    boxShadow: 'none',
                                    width: '100%',
                                    padding: '0px 24px 4px 0px',
                                    backgroundColor: 'rgba(255,255,255,0.1)',
                                }}
                            />
                        </Grid>
                        <CalendarMonthIcon className={'iconDatePicker'} />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default DateDisableForm;
